module.exports = __webpack_public_path__ + "media/images/wines/verdejo/bottle-detail-182846752044ec757e577414be77e2db.png";